import { Modal } from '@/components/modal';
import { CHAIN_COLUMNS, STRIKE_HELP, type ChainColumnHelp } from '@/lib/chain-columns';

/** What each column of the chain means and how it is calculated. */
export function ChainHelpDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} title="Option chain columns" onClose={onClose} className="w-[min(560px,calc(100vw-32px))]">
      <div className="scrollbar-thin overflow-y-auto px-3 py-2.5">
        <p className="mb-2.5 text-xs text-ink-2">
          S is the underlying’s price, K a contract’s strike, and K′ the strike of its neighbour — the next strike further out of the money in the same expiration. Prices are per
          share; one contract is 100 shares. The chip on each expiration counts calendar days to it (DTE) from today, Eastern time.
        </p>
        <dl className="flex flex-col divide-y divide-line">
          {[STRIKE_HELP, ...CHAIN_COLUMNS].map((column) => (
            <ColumnEntry key={column.key} column={column} />
          ))}
        </dl>
      </div>
    </Modal>
  );
}

function ColumnEntry({ column }: { column: ChainColumnHelp }) {
  return (
    <div className="py-2 first:pt-0 last:pb-0">
      <dt className="flex items-baseline gap-2">
        <span className="min-w-12 rounded-sm bg-surface-2 px-1.5 py-0.5 text-center text-[11px] font-semibold tabular">{column.label}</span>
        <span className="text-xs font-semibold">{column.name}</span>
      </dt>
      <dd className="mt-1 flex flex-col gap-1 text-xs text-ink-2">
        <p>{column.description}</p>
        {column.formula !== undefined && (
          <div className="rounded-md border border-line bg-page px-2 py-1 font-mono text-[11px] text-ink">
            {column.formula.map((line) => (
              <div key={line}>{line}</div>
            ))}
          </div>
        )}
        {column.note !== undefined && <p className="text-[11px] text-muted">{column.note}</p>}
      </dd>
    </div>
  );
}
